import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export const DisableEInvoicingModalMessage = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column" gap={Spacing.S8}>
      {t('disable_e_invoicing_modal.description')}
      <Flex alignItems="flex-start" gap={Spacing.S6}>
        {t('disable_e_invoicing_modal.description_detail1')}
      </Flex>
      <Flex alignItems="flex-start" gap={Spacing.S6}>
        {t('disable_e_invoicing_modal.description_detail2')}
      </Flex>
      <Flex alignItems="flex-start" gap={Spacing.S6}>
        {t('disable_e_invoicing_modal.description_detail3')}
      </Flex>
    </Flex>
  )
}
